
import { NgFor, NgIf, CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, Input, ViewChild, ViewEncapsulation, forwardRef } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute, NavigationStart, Params, Router, RouterLink, RouterOutlet } from '@angular/router';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { FileManagerComponent } from 'app/modules/admin/apps/file-manager/file-manager.component';
import { FileManagerService } from 'app/modules/admin/apps/file-manager/file-manager.service';
import { ItemPagination, BaseListReponse, assetsFilterFields, AssetsSearch, SortingPreference, pickerDirectory, OversizedFile } from 'app/modules/admin/apps/file-manager/file-manager.types';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { MatCheckbox, MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule, MatRippleModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule, Sort } from '@angular/material/sort';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { HttpClientModule } from "@angular/common/http";
import { MatTableModule } from '@angular/material/table';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { DocumentService } from 'app/services/document.service';
import { FuseLoadingBarComponent } from '@fuse/components/loading-bar';
import { MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';
import { EventService } from 'app/services/event.service';
import { Asset, CreateFolder, FileUploadOptions } from 'app/models/document';
import * as consts from 'app/shared/global-constants';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { FileUploader, FileUploadModule } from 'ng2-file-upload';
import { Util } from 'app/models/util';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { filter } from 'rxjs/operators';
import { FuseScrollbarDirective } from '@fuse/directives/scrollbar';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { fuseAnimations } from '@fuse/animations';
import { labelColorDefs } from 'app/modules/admin/apps/file-manager/file-manager.constants';
import { LabelService } from 'app/services/label.service';
import { DataVisualBarRecentComponent } from '../data-visuals/dv-bar-recent/dv-bar-recent.component';
import { FilterComponent } from '../filter/filter.component';
import { ToastrService } from 'ngx-toastr';
import { FavouriteService } from 'app/services/favourite.service';
import { FileSizePipe } from '@fuse/pipes/file-size.pipe';
import { LpmLabelPipe } from '@fuse/pipes/lpm-label.pipe';
import { FullNamePipe, getFullName } from '@fuse/pipes/full-name.pipe';
import { Title } from '@angular/platform-browser';
import { SharedDetailsComponent } from './shared-details/shared-details.component';
import { AuthService } from 'app/services/auth.service';
import { ActionRegistryService } from 'app/shared/action-registry.service';
import { ClickDebouncer } from 'app/shared/click-debouncer';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatDialog } from '@angular/material/dialog';
import { DndDraggableDirective, DndHandleDirective, DndDragImageRefDirective, DndDropzoneDirective } from 'ngx-drag-drop';
import { LpmConfig } from 'app/models/lpm.config';
import { NgxLoadingModule } from 'ngx-loading';
import { ActionDirective } from '@fuse/directives/action.directive';
import { AppActionId } from 'app/shared/action.types';
import { LockService } from 'app/services/lock.service';
import { DesktopAgentService } from 'app/services/desktop-agent.service';
import { DesktopAgentBannerComponent } from '../desktop-agent/desktop-agent-banner.component';
import { MatDividerModule } from '@angular/material/divider';
import { FileUploadQueueService } from 'app/services/file-upload-queue.service';
import { CUSTOM_THEME_ELEMENTS_CLASSES } from 'app/constants';
import { PermissionsService } from '../permissions/permissions.service';

@Component({
    selector: 'file-manager-shared',
    templateUrl: './shared.component.html',
    styleUrls: ['./shared.component.scss'],
    animations: [
        fuseAnimations,
        trigger('overlayAnimation', [
            transition(':enter', [
                style({ opacity: 0, transform: 'scale(0.5)' }),
                animate('300ms ease-out', style({ opacity: 1, transform: 'scale(1)' })),
            ]),
            transition(':leave', [
                animate('300ms ease-in', style({ opacity: 0, transform: 'scale(0.5)' })),
            ]),
        ]),
        trigger('slideDown', [
          state('void', style({
            height: '0',
            opacity: '0',
            overflow: 'hidden',
          })),
          state('*', style({
            height: '*',
            opacity: '1',
          })),
          transition(':leave', [
            animate('0.3s ease-out')
          ]),
        ]),
      ],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    // changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatSidenavModule,
        RouterOutlet,
        NgIf,
        RouterLink,
        NgFor,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        MatCheckboxModule,
        MatOptionModule,
        MatRippleModule,
        MatFormFieldModule,
        MatInputModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatSortModule,
        HttpClientModule,
        MatTableModule,
        MatMenuModule,
        CommonModule,
        MatExpansionModule,
        FileUploadModule,
        MatMenuModule,
        CommonModule,
        MatExpansionModule,
        MatPaginatorModule,
        ScrollingModule,
        FuseScrollbarDirective,
        DataVisualBarRecentComponent,
        FuseLoadingBarComponent,
        FilterComponent,
        FileSizePipe,
        forwardRef(() => LpmLabelPipe),
        FullNamePipe,
        SharedDetailsComponent,
        OverlayModule,
        DndDraggableDirective,
        DndHandleDirective,
        DndDragImageRefDirective,
        DndDropzoneDirective,
        NgxLoadingModule,
        ActionDirective,
        DesktopAgentBannerComponent,
        NgxLoadingModule,
        MatDividerModule,
        DesktopAgentBannerComponent
    ],
    // providers : [FileManagerComponent]
})
export class FileManagerSharedComponent {
    @Input() defaultView: string = null;
    @Input() lpm: LpmConfig = new LpmConfig();
    @ViewChild('matDrawer', { static: true }) matDrawer: MatDrawer;
    @ViewChild('viewport', { static: false }) viewport: CdkVirtualScrollViewport;

    drawerMode: 'side' | 'over';
    //items1: Items;
    assets: Asset[] = [];
    folders = null;
    files = null;

    displayedPaths: any[] = [];
    showFullPaths: boolean = false;
    totalAssets: { files: number; folders: number } = { files: 0, folders: 0 }
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    labelColors: any;
    labels = [];
    viewMode: any;

    page: ItemPagination = new ItemPagination();
    isLoading: boolean = true;
    access:boolean = false;

    // we create an object that contains coordinates
    menuTopLeftPosition = { x: 0, y: 0 };

    // reference to the MatMenuTrigger in the DOM
    @ViewChild('fmItemActionMenuItemTrigger', { static: true }) matMenuTrigger!: MatMenuTrigger;
    @ViewChild('filterPanel', { static: true }) filterPanel: MatExpansionPanel;
    @ViewChild('multiItemSelectPanel', { static: true }) multiItemSelectPanel: MatExpansionPanel;
    @ViewChild('statsPanel', { static: true }) statsPanel: MatExpansionPanel;

    selectedRows: Asset[] = [];
    routeFolderId = null;
    isStatsPanelOpen = false;

    public paths = [];
    pageLimitList = consts.pagelimits;
    total = 0;
    showScrollToTopButton = false;
    private scrollSubscription: Subscription;

    radius: number;
    color: string;
    assetsFilterFields: assetsFilterFields = new assetsFilterFields()
    assetsSearch: AssetsSearch = new AssetsSearch()

    teamDecorator = {};
    itemDecoratorComplete: boolean = false;

    assetId = null;
    activeTab = null;

    public trigger: HTMLElement | undefined;
    private previousUrl: string = '';

    isAuthorized:boolean=true
    subs = new Subscription();

    isAllRowsSelected:boolean = false;
    isWebComponent = this.util.getIsWebApp();

    // ── File upload ──────────────────────────────────────────────────────
    @ViewChild('uploaderInputHidden') uploaderInputHidden: ElementRef;
    @ViewChild('folderInput') folderInput!: ElementRef<HTMLInputElement>;
    isDragActive = false;
    fileUploader: FileUploader
    oversizedFiles:OversizedFile[] = []

    /**
     * Constructor
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        public _fileManagerComponent: FileManagerComponent,
        private _fileManagerService: FileManagerService,
        private _fuseConfirmationService: FuseConfirmationService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        public docService: DocumentService,
        public eventSer: EventService,
        public util: Util,
        private labelService: LabelService,
        private toastr: ToastrService,
        private favService: FavouriteService,
        private titleService: Title,
        private authService: AuthService,
        private _matDialog: MatDialog,
        private lockService: LockService,
        public uploadQueueService: FileUploadQueueService,
        private _permissionsService: PermissionsService,
        public desktopAgentService: DesktopAgentService,
        private _actionRegistry: ActionRegistryService,
    ) {
        if(!this.isWebComponent) this.titleService.setTitle("DMS - Shared");
        this._router.events
            .pipe(filter(event => event instanceof NavigationStart))
            .subscribe((event: NavigationStart) => {
                this.previousUrl = event.url;
            });
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this.configFilter()
        const sort = this.util.getSortingPreference('Shared');
        this.assetsSearch.sharedOnly = true;

        this.assetsSearch.sortColumn = sort?.sort?.active as any ?? 'FOLDER_CREATED_DATE';
        this.assetsSearch.sortDirection = this.util.getSortDirection(sort?.sort?.direction) ?? 'DESCENDING';
        this.page.size = Number(this.util.getPageLimit());
        const fileUploadOptions:FileUploadOptions = this.util.getFileUploadOptions(this.routeFolderId,this.lpm);
        // this.getSharedAssets()
        this.fileUploader = this.uploadQueueService.initUploader(fileUploadOptions);

        // Set the defaults
        this._fileManagerService.registerIcons();
        // TODO - set viewMode default based on user preference
        this.viewMode = this._fileManagerService.viewMode;
        // // Get the label colors
        this.labelColors = labelColorDefs;
        this.getLabels();

        this.subs.add(
        this.eventSer.getData.subscribe((data) => {
            this.getSharedAssets();
        })
      );

       this.subs.add(
            this.eventSer.resetRowsSelection.subscribe((data) => {
                this.cancelBulkAction()
              })
        );

        // route folder id, standalone only
        this._activatedRoute.params.subscribe((params: Params) => {
            const folderId = params['id'];
            if (folderId) this.setFolderSearch(folderId);
            else this.setRootSearch();

            this.getSharedAssets()
        });

        // Subscribe to media query change
        this._fuseMediaWatcherService.onMediaQueryChange$('(min-width: 1200px)')
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((state) => {
                // Calculate the drawer mode
                this.drawerMode = state.matches ? 'side' : 'over';

                // Mark for check
                this._changeDetectorRef.markForCheck();
            });

        this.configAfterFileUpload();
    }

    ngAfterViewInit(): void {
        if (this.assets.length > 0)
            setTimeout(() => this.subscribeToScrollEvent(), 4000);
    }

    async getSharedAssets() {
        this.isLoading = true;
        this.assets = [];
        this.resetSelectedRows();
        this.docService.getAssets(this.page, this.assetsSearch).then((res: BaseListReponse) => {
            this.assets = this.docService.getData(res);
            const meta = this.docService.getMeta(res);
            this.total = meta.total;

            this.totalAssets.files = meta.totalFiles
            this.totalAssets.folders = meta.totalFolders

            if (this.assets && this.assets.length > 0) {
                this.folders = this.assets.filter((item) => item.type === 'FOLDER');
                this.files = this.assets.filter((item) => item.type === 'FILE');
            }
            else {
                this.folders = []
                this.files = []
            }

            this.getPath()
            this.renderTeamMembers();
            this.isLoading = false
        }).catch(error => {
            console.log(error)
            this.isLoading = false
        })
    }

    getPath() {
        if (this.assetsSearch.parent && !this.isClientUploadsRoot) this.fetchtPath();
        else {
            this.displayedPaths = [];
            this.access = this.isClientUploadsRoot;
        }
    }

    async fetchtPath() {
        this.isLoading = true;
        this.docService.getAssetsPath(this.assetsSearch.parent).then((res) => {
            const response = this.docService.getData(res)
            this.paths = response
            this.updateDisplayedPaths();
            this.isLoading = false;

        }).catch((err) => {
            this.isLoading = false;
        })
        this._changeDetectorRef.markForCheck();
    }

    /**
     * Trims paths above the scoped root.
     * Prepends synthetic "Shared" root entry.
     */
    updateDisplayedPaths() {
        const share = {
            color: null,
            id: null,
            name: 'Shared',
            access : 'WRITER'
        }

        if (this.isWebComponent) {
            this.paths = this.util.scopePathToRoot(this.paths);
        }
        else this.paths.splice(0, 1);

        this.paths = this.trimClientUploadsPath(this.paths);
        this.paths.unshift(share)

        this.setAccess(this.paths)

        if (this.paths.length > 4) {
            this.displayedPaths = [{ name: '...' }, ...this.paths.slice(-3)];
        } else {
            this.displayedPaths = [...this.paths];
        }

    }

    setAccess(paths){
        if (!paths?.length) {
            this.access = false;
            return;
        }
        const access= paths[paths.length-1].access
        this.access=(access=='WRITER')||(access=='OWNER')
    }

    folderView(folderId:string) {
        if (this.isWebComponent) {
            if (this.isRootFolder(folderId)) this.setRootSearch();
            else this.setFolderSearch(folderId);
            this.page.page = 0;
            this.getSharedAssets();
        } else {
            this._router.navigateByUrl('apps/file-manager/shared/folders/' + folderId);
        }

    }

    // suggest writable folders to upload into
    getSuggestedUploadFolderNames(): string[] {
        const folderNames = (this.folders ?? [])
            .filter((f: Asset) => f.accessLevel === 'WRITER')
            .map((f: Asset) => f.name)
            .filter(Boolean);
        const knownNames = ['Client Bridge', 'Requested Document'];
        const matches = knownNames.filter(name =>
            folderNames.some((f: string) => f.toLowerCase() === name.toLowerCase())
        );

        return matches.length ? matches : folderNames.slice(0, 2);
    }

    // prompt to pick a folder first
    showUploadFolderPrompt(): void {
        const hasFolders = (this.folders ?? []).length > 0;
        const suggestions = this.getSuggestedUploadFolderNames();

        let message: string;
        let iconColor: 'primary' | 'warning' = 'primary';

        if (suggestions.length) {
            message = `Files and folders can only be uploaded into one of your shared folders.<br><br>` +
                `Please open a shared folder (e.g. ${suggestions.map(name => `<b>${name}</b>`).join(' or ')}), then use the Upload option inside it.`;
        } else if (hasFolders) {
            // no writable folders found
            iconColor = 'warning';
            message = `You don't currently have upload access to any of your shared folders.<br><br>` +
                `Upload access is needed for at least one shared folder before any files or folders can be uploaded.`;
        } else {
            // no folders shared yet
            iconColor = 'warning';
            message = `You don't have any shared folders yet.<br><br>` +
                `A folder needs to be shared with you before any files or folders can be uploaded.`;
        }

        this._fuseConfirmationService.open({
            title: 'Select a Folder to Upload',
            message,
            icon: { show: true, name: 'feather:info', color: iconColor },
            actions: {
                confirm: { show: true, label: 'OK', color: 'primary' },
                cancel: { show: false },
            },
            dismissible: true,
        });
    }

    /**
     * Toggles the display of full paths in the file manager list.
     * 
     * @param show - A boolean value indicating whether to show full paths or not.
     */
    toggleFullPaths(show: boolean, event?) {
        this.showFullPaths = show;
        if (this.showFullPaths)
            this.setOrigin(event);
    }

    setOrigin(event: MouseEvent): void {
        this.trigger = event.target as HTMLElement;
    }

    onPageChanged(e: PageEvent) {
        this.page.length = e.length;
        this.page.size = e.pageSize;
        this.page.page = e.pageIndex;
        this.util.setPageLimit(this.page.size);
        this.getSharedAssets()
    }

    sortData(sort: Sort) {
        this.page.orderOn = sort.active;
        this.assetsSearch.sortDirection = this.util.getSortDirection(sort.direction)
        const sortPrefernce: SortingPreference = { viewName: 'Shared', sort }
        this.util.setSortingPreference(sortPrefernce)
        this.assetsSearch.sortColumn = sort.active as any
        this.getSharedAssets()

    }

    getLabels() {
        this.labelService.getLabels().then((res) => {
            this.labels = this.labelService.getData(res);
        }).catch((error) => {
            console.log(error);
        })
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this.subs.unsubscribe();

        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
        if (this.scrollSubscription) {
            this.scrollSubscription.unsubscribe();
        }
    }

    subscribeToScrollEvent() {
        this.scrollSubscription = this.viewport.elementScrolled().subscribe(event => {
            this.handleScrollEvent(event);
        });
    }

    handleScrollEvent(event) {
        this.showScrollToTopButton = this.viewport.getOffsetToRenderedContentStart() > 30;
    }

    scrollToTop() {
        this.viewport.scrollTo({ top: 0, behavior: 'smooth' });
        this.showScrollToTopButton = false;
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * On backdrop clicked
     */
    onBackdropClicked(): void {
        // Go back to the list
        this._router.navigate(['./'], { relativeTo: this._activatedRoute });

        // Mark for check
        this._changeDetectorRef.markForCheck();
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }

    /**
     * Toggle the viewMode between 'grid' and 'cards'
     *
     * @param viewMode
     */
    toggleViewMode(): void {
        this.multiItemSelectPanel.close();
        this._fileManagerService.viewMode = this._fileManagerService.viewMode === 'grid' ? 'cards' : 'grid';
        this.viewMode = this._fileManagerService.viewMode;
    }

    /** 
     * Method called when the user click with the right button 
     * @param event MouseEvent, it contains the coordinates 
     * @param item Our data contained in the row of the table 
     */
    onRightClick(event: MouseEvent, selectedItem: Asset): void {

        // preventDefault avoids to show the visualization of the right-click menu of the browser 
        event.preventDefault();
        if (!this.hasMenuActions(selectedItem)) return;

        // we record the mouse position in our object 
        this.menuTopLeftPosition.x = event.clientX;
        this.menuTopLeftPosition.y = event.clientY;

        // we open the menu 
        // we pass to the menu the information about our object 
        this.matMenuTrigger.menuData = { item: selectedItem };

        // we open the menu 
        this.matMenuTrigger.openMenu();
    }

    /**
     * Toggle star
     */
    toggleStar(asset: Asset): void {
        asset.favourite = asset.favourite ? !asset.favourite : true;
        this.favService.favorite(asset.id, asset.favourite).then((res) => {
            if (!asset.favourite) {
                this.toastr.warning("Removed from favorite")
            } else {
                this.toastr.info("Added to favorite")
            }
            this.eventSer.checkUnreadMessages.emit("favourite");
            this.getSharedAssets()
        }).catch((error) => {
            console.log(error);
        })
    }

    /**
     * Toggle star
     */
    toggleStar_multi(): void {
        if (this.selectedRows.length > 0) {
            this.selectedRows.forEach(asset => {
                asset.favourite = !asset.favourite;
            });
        }
    }

    /**
     * Toggle the filterPanel open and close
     */
    toggleFilterPanel(): void {
        // toggle the filterPanel open and close
        this.filterPanel.toggle();
        // TODO - clear the filters on close

        //if opening the filterPanel, close the multiItemSelectPanel
        if (this.filterPanel.opened) {
            this.selectedRows = [];
            this.multiItemSelectPanel.close();
        }
    }

    /**
    * Toggle the statsPanel open and close
    */
    toggleStatsPanel(): void {
        // toggle the panel open and close
        console.log('toggleStatsPanel');
        this.statsPanel.toggle();
        // TODO - clear the filters on close 
    }

    // Helper function to check if a row is selected
    isSelected(file: any): boolean {
        return this.selectedRows.some(selectedFile => selectedFile.id === file.id);
    }

    cancelBulkAction(): void {
        this.selectedRows = [];
        this.multiItemSelectPanel.close();
        this.isAllRowsSelected = false;
    }

    download(asset: Asset): void {
        this._fileManagerService.openDialog_download(asset);
    }

    download_multi(): void {
        //TODO - download multiple files as a zip. Files will be identified in the backend by the selectedRows array. 
        //For each file, check if user has permission to download. If no permission, reject all and return error message.
        //If user has permission, download as zip.
        let assetIds: string[] = []
        if (this.selectedRows.length>1) {
            assetIds = this.selectedRows.map((x) => x.id);
            this._fileManagerService.openDialog_download_multi(assetIds)
        }
        else {
            const asset = this.selectedRows[0]
            this._fileManagerService.openDialog_download(asset);
        }
    }

    /**
     * Moves the specified file to the trash.
     * 
     * @param file - The file to be moved to the trash.
     * @param type - The type of file being moved to the trash.
     */
    trash(file: Asset): void {
        const ids: string[] = [file.id]
        this._fileManagerService.openDialog_trash(ids, file.type.toLowerCase());
    }

    /**
     * Trashes the selected assets.
     * If only one asset is selected, it trashes that asset.
     * If multiple assets are selected, it presents a confirmation prompt and then trashes all selected assets.
     */
    trash_multi(): void {
        if (this.selectedRows && this.selectedRows.length === 1) {
            this.trash(this.selectedRows[0]);
        } else {
            const ids: string[] = this.selectedRows.map(row => row.id)
            this._fileManagerService.openDialog_trash_multi(ids);
        }
    }

    stopPropagation(event: MouseEvent): void {
        this._fileManagerComponent.stopPropagation(event);
    }

    /**
     * Returns the color associated with the given file type.
     * 
     * @param filetype - The file type.
     * @returns The color associated with the file type.
     */
    getTypeColor(filetype: string): string {
        return this.util.getTypeColor(filetype);
    }

    onFilterChange(event) {
        this.assetsSearch = event
        this.assetsSearch.sortColumn = 'FOLDER_CREATED_DATE';
        this.assetsSearch.sortDirection = 'DESCENDING'
        this.getSharedAssets()
    }

    configFilter() {
        //to hide some fields in filter
        this.assetsFilterFields.modified = false
        this.assetsFilterFields.user = true
        this.assetsFilterFields.label = !this._actionRegistry.isHidden('filterByLabel', null, 'shared')
        this.assetsFilterFields.starred = !this._actionRegistry.isHidden('filterByFavorite', null, 'shared')
    }

    get canViewDetails(): boolean {
        return !this._actionRegistry.isHidden('details', null, 'shared');
    }

    // hide item menu when empty
    hasMenuActions(asset: Asset): boolean {
        if (!asset) return false;
        const isFile = asset.type === 'FILE';
        // [appAction] items, hidden only
        const attributeActions: AppActionId[] = isFile
            ? ['download', 'share', 'copy', 'openOnDesktop', 'rename', 'details', 'organize']
            : ['share', 'rename', 'details', 'organize'];
        // *appAction items, hidden when disabled
        const structuralActions: AppActionId[] = isFile
            ? ['view', 'edit', 'lock', 'requestAccess', 'unlock', 'delete']
            : ['delete'];
        return attributeActions.some(action => !this._actionRegistry.isHidden(action, asset, 'shared'))
            || structuralActions.some(action => !this._actionRegistry.isRemoved(action, asset, 'shared'));
    }

    // hide breadcrumb menu when empty
    get hasBreadcrumbActions(): boolean {
        return !this._actionRegistry.isHidden('share', null, 'shared') || this.canViewDetails;
    }

    toggleLabel(assetId: string, labelId: string, event: MatCheckbox): void {
        if (!event.checked) {
            this.labelService.assignLabel(labelId, assetId).then((res) => {
                this.toastr.info("Label applied");
                this.getSharedAssets();
            }).catch((error) => {
                console.log(error);
            })
        } else this.deleteLabel(labelId, assetId);
    }

    deleteLabel(labelId: string, assetId: string) {
        this.labelService.removeLabel(labelId, assetId).then((res) => {
            this.toastr.warning("Label removed");
            this.getSharedAssets();
        }).catch((error) => {
            console.log(error);
        })
    }

    selectedLabel(id: string, list: any[]) {
        return this.util.selectedLabel(id, list);
    }

    /**
     * Moves the specified asset to a different location.
     * If multiple rows are selected, it calls the `move_multi` method.
     * Otherwise, it opens the move item dialog for the selected asset.
     * 
     * @param item - The asset to be moved.
     */
    move(item: Asset): void {
         if(!this._permissionsService.canMove(item)){
            this.toastr.error("You do not have permission to move this item.");
            return;
        }

        if (this.selectedRows.length > 1) {
            this.move_multi();
        } else {
            this._fileManagerComponent.moveItemDialog(item);
        }
    }

    /**
     * Moves multiple selected rows to a new location.
     */
    move_multi(): void {
         this.selectedRows.forEach(row => {
            if(!this._permissionsService.canMove(row)){
                this.toastr.error(`You do not have permission to move ${row.name}.`);
                return;
            }
        });
        this._fileManagerComponent.moveItemDialogMuti(this.selectedRows);
    }

    renderTeamMembers() {
        this.assets.forEach((asset: Asset) => {
            asset["innerDiv"] = "";

            if (asset.createdBy.profilePic) {
                asset["innerDiv"] += `<img
                class="shrink-0 w-10 h-10 mr-4 rounded-full overflow-hidden object-cover object-center"
                src="${asset.createdBy.profilePic}"
                [alt]="'Activity image'">`;
            } else {
                const name = getFullName(asset.createdBy).toUpperCase();
                const dec_class = this.util.getUserColor(name);
                const [first, last] = name.split(" ");

                const initials = `${first?.substring(0, 1) || ''}${last?.substring(0, 1) || ''}`;
                this.teamDecorator[name] = initials;
                
                asset["innerDiv"]       += ` <div class=" ${dec_class} flex shrink-0 items-center justify-center w-10 h-10 mr-4 rounded-full font-10">
                    ${this.teamDecorator[name]}
                </div>`;
            }
        });
        this.itemDecoratorComplete = true;
    }

    /**
  * Copies an asset.
  * 
  * @param asset - The asset to be copied.
  */
    copyAsset(asset: Asset) {
        let assetIds:string[]=[]
        if(this.selectedRows.length){
            assetIds=this.selectedRows.map(row=>{
                return row.id
            })
        }
        else
        {
            assetIds=[asset.id]
        }
        this.docService.copyAsset(assetIds, asset?.parent?.id).then(res => {
            const itemStr=this.util.pluralize('item',this.selectedRows.length)
            this.toastr.info(`${itemStr} copied`);
            this.getSharedAssets()
        }).catch(error => {
            console.log(error)
        })
    }

    /**
    * Sets the `assetId` and `activeTab` properties based on the provided `id` and `tab` values.
    * @param id - The ID of the asset.
    * @param tab - The active tab index (default is '0').
    */
    drawerView(id, tab = null) {
        if (!this.canViewDetails) return; // details hidden for host
        const currentPath = this._router.url; ``
        this.previousUrl;
        if (this.isWebComponent) {
            this.assetId = id;
            this.activeTab = tab ? tab : '0';
        } else {
            if (currentPath.includes('/shared/folders/')) {

                tab ? this._router.navigate(currentPath.includes('/details/') ? [`apps/file-manager/shared/folders/${this.routeFolderId}/details/`, id] : [currentPath + '/details/', id], { queryParams: { activeTab: tab } })
                    : this._router.navigate(currentPath.includes('/details/') ? [`apps/file-manager/shared/folders/${this.routeFolderId}/details/`, id] : [currentPath + '/details', id]);
            }
            else {

                tab ? this._router.navigate(currentPath.includes('/details/') ? ['apps/file-manager/shared/details/', id] : [currentPath + '/details/', id], { queryParams: { activeTab: tab } }) :
                    this._router.navigate(currentPath.includes('/details/') ? ['apps/file-manager/shared/details/', id] : [currentPath + '/details', id]);
            }

        }

    }
    editFile(asset: Asset) {
        this.editFileInNewApp(asset, false) //edit existing file
    }

    /**
 * Opens the file in a new tab for preview after getting temporary token for authentication
 * @param asset - The asset object to be opened.
 */
    previewFile(asset: Asset) {
      this.util.viewFile(asset);
    }

    /**
     * Opens the file in the DMS Desktop Agent using the drive:// custom protocol.
     * @param asset - The file asset to open.
     */
    viewInDesktop(asset: Asset): void {
        this.desktopAgentService.launch(asset);
    }

    private readonly _clicks = new ClickDebouncer();

    drawerViewClick(id: string): void {
        this._clicks.click(() => this.drawerView(id));
    }

    drawerViewDblClick(asset: Asset): void {
        this._clicks.dblClick(() => {
            if (asset.type === 'FOLDER') {
                this.folderView(asset.id);
            } else if (this._actionRegistry.isAllowed('view', asset)) {
                this.previewFile(asset);
            } else if (this._actionRegistry.isAllowed('openOnDesktop', asset)) {
                this.viewInDesktop(asset);
            } else {
                this.drawerView(asset.id);
            }
        });
    }

    /**
     * Opens the file in a new tab for editing after getting temporary token for authentication
     * @param asset - The asset to edit.
     * @param isNew - Indicates whether the asset is new or not. Default is false.
     */
    editFileInNewApp(asset: Asset, isNew: boolean = false) {

        // first get temporary token for authentication

        const assetId = isNew ? this.routeFolderId : asset.id;
        const assetName = isNew ? "new_doc" : encodeURIComponent(asset.name);

        this.authService.getToken().then((res) => {
            const token = this.docService.getData(res).token
            const dms_editor_url = this.util.getDmsEditorUrl()
            const user_type = this.getUsertype();
            const url = dms_editor_url + "/#/auth/" + assetId + "/" + "?name=" + assetName + "&new=" + isNew + "&t=" + token+"&dut="+user_type;
            this.util.openExternalViewEditLink(url);
        })
            .catch((err) => {
                console.log(err);
            });
    }

    animationStarted(event){
    }

    /**
     * Hides the breadcrumb in the file manager list component.
     */
    hideBreadCrumb(){
        this.showFullPaths=false;
    }

    /**
     * Creates a new file.
     */
    createNewFile() {
        this.editFileInNewApp(null, true) //create new file
    }

    /**
     * Opens the file manager and allows the user to select a directory.
     * Traverses the selected directory and creates a folder structure in the application.
     * Uploads the folder structure to the server and retrieves the assets.
     */
    async openFileManager() {
        // Chrome / Edge, i.e Supported browsers
        if ('showDirectoryPicker' in window) {
            try {
                const folder = await (window as any).showDirectoryPicker();
                const hierarchyAndMaxSizeFiles = await this.util.traverseDirectory(folder);
                const hierarchy = hierarchyAndMaxSizeFiles.hierarchy;
                this.oversizedFiles = [...this.oversizedFiles, ...hierarchyAndMaxSizeFiles.oversizedFiles];
                const isParentIncluded: boolean = await this.util.shouldIncludeParentFolderInUpload(folder.name, this.lpm);
                await this.validateAndUploadFolder(folder, hierarchy, isParentIncluded);

            } catch (e) {
                // User cancelled picker
                return;
            }
        }

        // Unsupported browsers
        else {
            this.folderInput.nativeElement.value = '';
            this.folderInput.nativeElement.click();
        }
    }

    /**
     * Confirms oversized files (if any) before uploading a folder tree.
     * @param folder - Selected folder handle.
     * @param hierarchy - Folder hierarchy to upload.
     * @param isParentIncluded - Include the selected folder itself (default true).
     */
    async validateAndUploadFolder(folder: { name: string }, hierarchy: pickerDirectory[], isParentIncluded: boolean = true): Promise<void> {
        if (this.oversizedFiles.length) {
            const confirmed = await this.confirmOversizedFiles();
            if (!confirmed) return;
        }
        await this.uploadFolder(folder, hierarchy, isParentIncluded);
        this.getSharedAssets(); // refresh once; folder creation bypasses the upload-queue's onCompleteAll refresh
    }

    /**
     * Shows the oversized-files dialog. Resolves true if the user proceeds,
     * false if cancelled; clears oversizedFiles either way.
     */
    private confirmOversizedFiles(): Promise<boolean> {
        return new Promise<boolean>((resolve) => {
            const fileList = this.oversizedFiles.map((file, index) =>
                `<div title="${file.path}" class="flex justify-between"><div class="flex-grow flex basis-0"><b>${index + 1}:</b> <span class="line-clamp-1">${file.name}</span></div><b> (${file.size})</b></div>`
            ).join('');
            const message = `${this.oversizedFiles.length} file(s) exceed(s) the maximum allowed size (${this.util.formatBytes(consts.DMS_MAX_FILE_SIZE_BYTES)}) and cannot be uploaded:<br/><br/>${fileList}<br/>Do you want to continue?`;
            const dialogRef = this._fuseConfirmationService.open({
                message,
                title: 'Size Exceeded',
                icon: { color: 'info', name: 'feather:database', show: true },
                actions: {
                    confirm: { label: 'Proceed' },
                    cancel: { show: true, label: 'Cancel upload' },
                },
            });
            dialogRef.afterClosed().subscribe((result) => {
                this.oversizedFiles = [];
                resolve(result === 'confirmed');
            });
        });
    }

    /**
     * Entry point for one dropped/picked folder; delegates to uploadFolderTree.
     * @param folder - The dropped/picked folder (uses folder.name).
     * @param hierarchy - Parsed folder/file tree to recreate on the server.
     * @param isParentIncluded - Whether to wrap contents in a new folder for `folder` itself.
     */
    async uploadFolder(folder: { name: string }, hierarchy: pickerDirectory[], isParentIncluded: boolean) {
        let lastCreatedFolderId = this.routeFolderId;

        if (isParentIncluded) {
            const res: any = await this.createFolder(folder.name, this.routeFolderId);
            lastCreatedFolderId = res.data.id;
        }

        // Recursively recreate the folder/file tree under the resolved parent id
        await this.uploadFolderTree(
            hierarchy,
            lastCreatedFolderId
        );
        this.configFileUpload(); // reset uploader target
    }

    async onFolderInputChange(event: Event) {
        const input = event.target as HTMLInputElement;
        if (!input.files || input.files.length === 0) {
            return;
        }

        const hierarchyAndMaxSizeFiles = this.util.buildHierarchyFromFiles(input.files);
        const hierarchy = hierarchyAndMaxSizeFiles.hierarchy;
        this.oversizedFiles = [...this.oversizedFiles, ...hierarchyAndMaxSizeFiles.oversizedFiles];
        // Infer root folder name from first file
        const firstPath = input.files[0].webkitRelativePath;
        const folderName = firstPath.split('/')[0];

        const folder = { name: folderName };

        const isParentIncluded = await this.util.shouldIncludeParentFolderInUpload(folderName, this.lpm);
        await this.validateAndUploadFolder(folder, hierarchy, isParentIncluded);
    }

    /**
     * Recursively recreates a folder/file tree on the server.
     * @param hierarchy - Folder/file tree to recreate.
     * @param parentId - Server folder ID to create/upload this level into.
     * @param currentPath - Path built up so far, for reporting oversized nested files.
     */
    async uploadFolderTree(hierarchy: pickerDirectory[], parentId: string = null, currentPath: string = '') {
        for (const item of hierarchy) {
            const itemPath = currentPath ? `${currentPath}/${item.name}` : item.name;
            if (item.type === 'directory') {
                // Create the folder and obtain its ID
                const res: any = await this.createFolder(item.name, parentId);
                // Recursively upload the contents of the folder
                const folderId = res.data.id;
                await this.uploadFolderTree(item.children, folderId, itemPath);
            } else if (item.type === 'file') {
                // Upload the file to the parent folder
                if (item.file.size < consts.DMS_MAX_FILE_SIZE_BYTES) {
                    await this.uploadFile(item.file, parentId);
                }
                else
                {
                    const MB = this.util.formatBytes(item.file.size, 1);
                    const oversizedFile = { name: item.file.name, size: MB, path: itemPath };
                    this.oversizedFiles.push(oversizedFile);
                }
            }
        }
    }

    /**
     * Creates a new folder on the server. Used for both the picked/dropped
     * folder's own wrapper and each subfolder while recreating a tree.
     * @param name - Folder name to create.
     * @param parentFolderID - Parent folder ID.
     * @returns Server response for the created folder.
     */
    createFolder(name: string, parentFolderID: string): Promise<any> {
        const folder = new CreateFolder();
        folder.name = name;
        return this.docService.createAsset(folder, parentFolderID).catch(error => {
            console.log(error);
            throw error;
        });
    }

    /**
     * Uploads a file to the server.
     *
     * @param file - The file to be uploaded.
     * @param parentId - The ID of the parent element.
     */
    uploadFile(file: File, parentId: string) {
        this.configFileUpload(parentId);
        this.uploadQueueService.uploader.addToQueue([file]);
        this.uploaderInputHidden.nativeElement.value = '';
        this.uploadQueueService.show();
        this.uploadQueueService.uploader.uploadAll();
    }

    fileOverBase(_e: any): void {
        if (!this.isDragActive) {
            this.isDragActive = true;
        }
    }

    async onNativeDrop(event: DragEvent): Promise<void> {
        this.isDragActive = false;

        if (!this.access || this.routeFolderId === null) {
            this.toastr.error('You do not have permission to upload to this folder.');
            return;
        }

        const items = event.dataTransfer?.items;
        if (!items) return;

        const targetFolderId = this.routeFolderId;

        const folderEntries: FileSystemDirectoryEntry[] = [];
        const fileEntries: FileSystemFileEntry[] = [];
        for (const item of Array.from(items)) {
            const entry = item.webkitGetAsEntry?.();
            if (entry?.isDirectory) {
                folderEntries.push(entry as FileSystemDirectoryEntry);
            } else if (entry?.isFile) {
                fileEntries.push(entry as FileSystemFileEntry);
            }
        }
        if (folderEntries.length === 0 && fileEntries.length === 0) return;

        this.uploadQueueService.startPreparing();

        const droppedFiles = await Promise.all(fileEntries.map(entry => this.util.getFileFromDroppedEntry(entry)));
        const validFiles: File[] = [];
        for (const file of droppedFiles) {
            if (file.size < consts.DMS_MAX_FILE_SIZE_BYTES) {
                validFiles.push(file);
            } else {
                this.oversizedFiles.push({ name: file.name, size: this.util.formatBytes(file.size, 1), path: file.name });
            }
        }

        // Phase 1: traverse all folders, accumulate oversized files with full path context
        const uploads: { folder: { name: string }, hierarchy: any[], isParentIncluded: boolean }[] = [];
        for (const folderEntry of folderEntries) {
            const result = await this.util.traverseDroppedDirectory(folderEntry);
            this.oversizedFiles.push(
                ...result.oversizedFiles.map(f => ({ ...f, path: `${folderEntry.name}/${f.path}` }))
            );
            const folder = { name: folderEntry.name };
            const isParentIncluded = await this.util.shouldIncludeParentFolderInUpload(folderEntry.name, this.lpm);
            uploads.push({ folder, hierarchy: result.hierarchy, isParentIncluded });
        }

        // Sequential, not concurrent: concurrent folders interleave on the shared
        // ng2-file-upload queue and each trigger their own onCompleteAll → getSharedAssets().
        const runUploads = async () => {
            for (const { folder, hierarchy, isParentIncluded } of uploads) {
                await this.uploadFolder(folder, hierarchy, isParentIncluded);
            }
            for (const file of validFiles) {
                await this.uploadFile(file, targetFolderId);
            }
            this.getSharedAssets(); // refresh once for the whole batch, not once per folder/file
        };

        // Phase 2: one dialog for all oversized files, then upload everything valid
        if (this.oversizedFiles.length) {
            const confirmed = await this.confirmOversizedFiles();
            if (!confirmed) {
                this.uploadQueueService.stopPreparing();
                return;
            }
        }

        await runUploads();
        this.uploadQueueService.stopPreparing();
    }

    onDragLeave(_e: any): void {
        this.isDragActive = false;
    }

     /**
     * Configures the file uploader after a file upload.
     */
    configAfterFileUpload(){
        this.uploadQueueService.onCompleteItem$.pipe(takeUntil(this._unsubscribeAll)).subscribe(({item, response}) => {
            try {
                const newAsset: Asset = JSON.parse(response)?.data;
                if (item.some.duplicate_action === 'overwritten') {
                    this.replaceUploadedFile(newAsset);
                } else {
                    this.appendUploadedFile(newAsset);
                }
            } catch (error: any) {
                if (this.util.InvalidErrorResponse(error.message)) {
                    throw('Invalid Error Response');
                }
            }
        });

        this.uploadQueueService.onCompleteAll$.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
            if (!this.uploadQueueService.pendingExistFiles.length) {
                this.getSharedAssets();
            }
        });

    }

    /**
     * Configures the file upload functionality.
     *
     * @param parentId - The ID of the parent element.
     */
    configFileUpload(parentId?: string) {
        const folderId = parentId ? parentId : this.routeFolderId;
        const fileUploadOptions = this.util.getFileUploadOptions(folderId, this.lpm);
        this.fileUploader = this.uploadQueueService.initUploader(fileUploadOptions);
        this.uploadQueueService.copilotConfig = this.lpm?.copilotConfig ?? null;
    }

     /**
     * Handles the event when a file is selected.
     * @param event - The event object containing the selected files.
     */
     onFileSelected(event) {
        let files:File[] = event.target.files;
        const {files:allowedFiles, oversizedFiles:newOversizedFiles} = this.util.filterOversizedFiles(files);
        files = allowedFiles;
        this.oversizedFiles.push(...newOversizedFiles);

        const startUpload = () => {
            this.configFileUpload();
            this.uploadQueueService.uploader.addToQueue(files);
            this.uploaderInputHidden.nativeElement.value = '';
            this.uploadQueueService.show();
            this.uploadQueueService.uploader.uploadAll();
        };

        if (this.oversizedFiles.length) {
            this.confirmOversizedFiles().then(confirmed => {
                if (confirmed && files.length > 0) {
                    startUpload();
                }
            });
            return;
        }

        startUpload();

    }

    toggleCheckAll():void {

        this.isAllRowsSelected = !this.isAllRowsSelected;

        if (this.isAllRowsSelected) {
            this.selectedRows = this.assets;
        }
        if (!this.isAllRowsSelected) {
            this.selectedRows = [];
        }

        this.toggleMultiRowSelectedOptions()
    }

    toggleRowCheck(checked: boolean, asset: Asset = null):void {

        if (checked) {
            this.selectedRows.push(asset)
        } else {
            this.selectedRows = this.selectedRows.filter(row => row.id !== asset.id);
        }

        this.isAllRowsSelected = this.selectedRows.length === this.assets.length;

        this.toggleMultiRowSelectedOptions()

    }

    resetSelectedRows():void {
        this.selectedRows = [];
        this.isAllRowsSelected = false;
        this.multiItemSelectPanel.close();
    }

    isSelectedRow(asset: Asset):boolean {
        return this.selectedRows.some(item => item.id === asset.id)
    }

    isFolderRowSelected():boolean {
        const index = this.selectedRows.findIndex(row => row.type == 'FOLDER')
        return index !== -1

    }

    toggleMultiRowSelectedOptions():void {
        if (this.selectedRows.length > 0) {
            this.multiItemSelectPanel.open();
            this.eventSer.multiRowSelect.emit();
        } else {
            this.multiItemSelectPanel.close();
        }
    }

    getUsertype():string{
        let user_type = 'D';
        if(!this.isWebComponent) return user_type;
        user_type = consts.USER_TYPE_QUERY_MAPPING[this.lpm.scope];
        return user_type;
    }

    checkInAsset(asset: Asset) {
        const ids = [asset.id];
        this.isLoading = true;
        this.lockService.checkInAsset(ids).then(res => {
            this.isLoading = false;
            this.toastr.success("Unlocked Successfully", 'Success');
            this.getSharedAssets();
        }).catch(error => {
            this.isLoading = false;
            console.log(error);
        })
    }

    requestRelease(asset: Asset) {
        const dialogRef = this._fuseConfirmationService.open({ message: `<b>"${asset.name}"</b> is locked. Press Confirm to Request Access.`, icon: { color: 'primary', name: 'feather:move' } });

        // Subscribe to afterClosed from the dialog reference
        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'confirmed') {
                const ids = [asset.id];
                this.isLoading = true;
                this.lockService.requestRelease(ids).then(res => {
                    this.isLoading = false;
                    this.toastr.success("Released request sent successfully", 'Success')
                    this.getSharedAssets();
                }).catch(error => {
                    this.isLoading = false;
                    console.log(error)
                })

            }
        });

    }

    checkoutAsset(asset: Asset) {
        const ids: string[] = [asset.id]
        this.lockService.checkOutAsset(ids).then(res => {
            this.toastr.success("Locked SuccessFully", 'Success');
            this.getSharedAssets();
        }).catch(error => {
            console.log(error);
        })
    }

    /**
  * onDragStart:
  * catch the drag start event; configure the UI representation of the draggable item
  */
    onDragStart(event, asset: Asset) {
        this.util.onDragStart(event, asset);
    }

    // append Uploaded file to the list of assets to show in the UI.
    appendUploadedFile(newAsset: Asset): void {
        if (!newAsset) return;

        const uploadedToFolder = newAsset.parent?.id ?? null;
        const activeFolder = this.routeFolderId ?? null;
        if (uploadedToFolder !== activeFolder) return;

        if (newAsset.type === 'FILE') {
            this.files = [...(this.files || []), newAsset];
            this.totalAssets.files++;
        } else if (newAsset.type === 'FOLDER') {
            this.folders = [...(this.folders || []), newAsset];
            this.totalAssets.folders++;
        }
        this.assets = [...(this.folders || []), ...(this.files || [])];
        this.total++;
    }

    replaceUploadedFile(newAsset: Asset): void {
        if (!newAsset) return;

        const uploadedToFolder = newAsset.parent?.id ?? null;
        const activeFolder = this.routeFolderId ?? null;
        if (uploadedToFolder !== activeFolder) return;

        const idx = (this.files || []).findIndex((f: Asset) => f.name === newAsset.name);
        if (idx === -1) {
            this.files = [...(this.files || []), newAsset];
            this.totalAssets.files++;
            this.total++;
        } else {
            const updated = [...this.files];
            updated[idx] = newAsset;
            this.files = updated;
        }
        this.assets = [...(this.folders || []), ...(this.files || [])];
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Shared root / Client Uploads (PP portal)
    // -----------------------------------------------------------------------------------------------------

    /** Client Uploads folder, PracticePanther portal users only. */
    get clientUploadsFolderId(): string {
        const isPracticePantherPortalUser = this.lpm?.host === 'PracticePanther' && this.lpm?.scope === 'EXT';
        if (!isPracticePantherPortalUser) return null;

        return this.lpm.clientUploadsFolderId ?? null;
    }

    /** Showing client uploads + top shared. */
    get isClientUploadsRoot(): boolean {
        return !!this.assetsSearch.includeTopShared;
    }

    // root crumbs map to root
    private isRootFolder(folderId: string): boolean {
        if (!folderId) return true;
        const clientUploadsId = this.clientUploadsFolderId;
        if (!clientUploadsId) return false;

        const isClientUploadsFolder = folderId === clientUploadsId;
        const isSessionRootFolder = folderId === this.util.getRootFromSession();
        return isClientUploadsFolder || isSessionRootFolder;
    }

    private setRootSearch(): void {
        const clientUploadsId = this.clientUploadsFolderId;
        if (clientUploadsId) {
            // client uploads + top shared
            this.assetsSearch.includeTopShared = true;
            this.assetsSearch.sharedOnly = null;
        } else {
            // shared items only
            this.assetsSearch.includeTopShared = null;
            this.assetsSearch.sharedOnly = true;
        }
        this.access = !!clientUploadsId;
        this.setActiveFolder(clientUploadsId);
    }

    private setFolderSearch(folderId: string): void {
        this.assetsSearch.includeTopShared = null;
        this.assetsSearch.sharedOnly = false;
        this.setActiveFolder(folderId);
    }

    // reset uploader so uploads don't target an old folder
    private setActiveFolder(folderId: string): void {
        this.routeFolderId = folderId;
        this.assetsSearch.parent = folderId;
        this.fileUploader = this.uploadQueueService.initUploader(this.util.getFileUploadOptions(folderId, this.lpm));
    }

    // hide client uploads and above
    private trimClientUploadsPath<T extends { id?: string }>(paths: T[]): T[] {
        const index = this.clientUploadsFolderId
            ? paths.findIndex((path) => path.id === this.clientUploadsFolderId)
            : -1;
        return index > -1 ? paths.slice(index + 1) : paths;
    }

}
